import type { FunctionComponent } from 'react';

export const ProgressCircleOutline: FunctionComponent<{
    readonly circleLength: number;
    readonly cx: number | string;
    readonly cy: number | string;
    readonly dashLength: number;
    readonly radius: number;
    readonly strokeWidth: number;
    readonly transform: string;
}> = ({ circleLength, cx, cy, dashLength, radius, strokeWidth, transform }) => {
    return (
        <circle
            className="in-data-[is-active=true]:!stroke-accent"
            cx={cx}
            cy={cy}
            r={radius}
            stroke="var(--semantic-text-on-accent)"
            strokeDasharray={`${dashLength} ${circleLength}`}
            strokeLinecap="round"
            strokeWidth={strokeWidth + 2.5}
            transform={transform}
        />
    );
};
